import { render, staticRenderFns } from "./LeftSideMenuUser.vue?vue&type=template&id=38eed0a6&scoped=true&"
import script from "./LeftSideMenuUser.vue?vue&type=script&lang=js&"
export * from "./LeftSideMenuUser.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideMenuUser.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LeftSideMenuUser.vue?vue&type=style&index=1&id=38eed0a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eed0a6",
  null
  
)

export default component.exports